import HeroIcon from "./HeroIcon";
import { Workflow } from "./interface";
import TruncateTooltip from "./TruncateTooltip";
import { getWorkflowOutputIconUrls } from "./utils";
import { CalendarIcon, DocumentTextIcon, ExclamationCircleIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";

interface Props {
  workflow: Workflow;
  onSelect: (workflow: Workflow) => void;
  isInstant?: boolean;
}

function WorkflowListItem(props: Props) {
  const { t } = useTranslation();
  const { workflow } = props;

  const outputIcons = getWorkflowOutputIconUrls(workflow);

  function handleOnClick() {
    if (workflow.status === "INCOMPLETE")
      return window.open(`https://app.portant.co/w/${workflow.id}`, "_blank");

    props.onSelect(workflow);
  }

  return (
    <div
      className="flex items-center gap-4 h-16 px-3 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors"
      onClick={handleOnClick}
    >
      <div
        className="relative flex items-center justify-center w-10 h-10 rounded flex-shrink-0"
        style={{ backgroundColor: workflow.color }}
      >
        <HeroIcon icon={workflow.icon} className="w-5 h-5 text-white" />
        {workflow.status === "INCOMPLETE" &&
          <div className="absolute -top-1.5 -right-1.5 w-5 h-5 bg-yellow rounded-full flex items-center justify-center shadow">
            <ExclamationCircleIcon className="w-4 h-4 text-white" />
          </div>
        }
      </div>

      <TruncateTooltip label={workflow.name} className="flex-1 font-gilroy font-semibold text-lg text-black" />

      {outputIcons.length > 0 &&
        <div className="flex items-center gap-2 flex-shrink-0">
          {outputIcons.map((icon, index) => (
            <img key={index} src={icon} alt="" className="w-4 h-4" />
          ))}
        </div>
      }

      {props.isInstant
        ? <div className="flex-shrink-0 bg-blue-50 text-blue text-xs font-semibold font-gilroy rounded-full px-2 py-0.5">
            {t("Portant Template")}
          </div>
        : <div className="flex items-center justify-end gap-4 flex-shrink-0 w-24 text-sm font-gilroy text-gray-500">
            <div className="relative group flex items-center gap-1">
              <DocumentTextIcon className="w-4 h-4 text-gray-400" />
              <span className="tabular-nums">{workflow.itemsTotal}</span>
              <span className="tooltip right-0 -top-1 -translate-y-full">
                {t("Total usage")}
              </span>
            </div>
            <div className="relative group flex items-center gap-1">
              <CalendarIcon className="w-4 h-4 text-gray-400" />
              <span className="tabular-nums">{workflow.itemsPeriod}</span>
              <span className="tooltip right-0 -top-1 -translate-y-full">
                {t("Usage this period")}
              </span>
            </div>
          </div>
      }
    </div>
  );
}

export default WorkflowListItem;
